// extracted by mini-css-extract-plugin
export default {"wrapper":"PageInput__wrapper-cFUaC","input":"PageInput__input-h9Gz3"};